import { Component, Output, Input, EventEmitter, OnInit, OnDestroy, AfterViewInit } from '@angular/core';
import { BackendService } from 'src/app/services/backend.service';
import { Router, NavigationEnd } from '@angular/router';
import { TranslateService } from '@ngx-translate/core';
import { HostListener } from '@angular/core';
import { LocationStrategy } from '@angular/common';

import { ViewChild } from '@angular/core';
import { FormControl } from '@angular/forms';
import {MatSelect} from '@angular/material';
import { ReplaySubject, Subject } from 'rxjs';
import { take, takeUntil } from 'rxjs/operators';

@Component({
  selector: 'seleccionar-paciente',
  templateUrl: './seleccionar-paciente.component.html',
  styleUrls: ['./seleccionar-paciente.component.scss']
})
export class SeleccionarPacienteComponent implements OnInit, AfterViewInit, OnDestroy{

  @Output() pacienteSeleccionadoEvent = new EventEmitter();
  @Output() addPacienteEvent = new EventEmitter();

  public error: boolean = false;
  public cargado: boolean = false;
  public editando: boolean = false;
  public adding: boolean = false;
  public paciente;
  public datos: Array<any>=[];
  public entities: Array<any>=[];
  public places: Array<any>=[];
  private querySubscription;
  public without_institution:boolean = false;

  /** control for the selected patient */
  public patientCtrl: FormControl = new FormControl();
  /** control for the MatSelect filter keyword */
   public patientFilterCtrl: FormControl = new FormControl();
  /** list of patients filtered by search keyword */
  public filteredPatients: ReplaySubject<any[]> = new ReplaySubject<any[]>(1);
  /** Subject that emits when the component has been destroyed. */
  private _onDestroy = new Subject<void>();
  @ViewChild('singleSelect') singleSelect: MatSelect;

  public selected_view: String = "";
  public isCollaborator = false;
  
  constructor(private backendService : BackendService, private locationStrategy: LocationStrategy){
    this.paciente = null;
    /*this.preventBackButton();*/
  }

  ngOnInit(){
    console.log('Cargado seleccionar-paciente.component.ts');
    /*console.log('Cargando la última entrada de cada usuario y los datos de los lugares y entidades');*/
    /*console.log(this.singleSelect);*/
    this.selected_view = window.localStorage.getItem('selected_view');
    this.isCollaborator = (window.localStorage.getItem("selected_view") =="collaborator");

    this.cargarDatos();
    //cuando se seleccione una persona, se almacenará en paciente
    this.patientCtrl.valueChanges.subscribe((value) => {
      console.log(value);
      this.paciente=value;
      this.finalizar();
    });
  }
  
  
  cargarDatos(){    
    this.cargarInstituciones();

    if (this.selected_view=="institutional_user"){
      this.querySubscription = this.backendService.getCiudadanoLastEntries().subscribe((res) => {
          if (res["errorCode"] > 0) {
              this.error = false;
              this.cargado = true;
              this.datos = res["data"];
              this.cargarSelector();
          } else {
              this.error = true;
              this.cargado = true;
          }
      },
      (error) => {
          this.error = true;
          this.cargado = true;
      });
    }
    else{
      this.error = false;
      this.cargado = true;
      this.datos = [];
      this.filteredPatients.next(this.datos.slice());
      this.setOnChangeNumberListener();
    }
  }

  cargarInstituciones(){
    /*console.log('Guardando referencia a la version actual');*/

    this.querySubscription = this.backendService.getInstitution().subscribe((res) => {
     /*console.log(res);*/
        if (res["errorCode"] > 0) {
            this.error = false;
            this.cargado = true;
            this.entities = res["data"];
            if (this.entities.length==0){
              this.without_institution=true;
            }else{
              this.cargarLugares();
            }
        } else {
          this.without_institution=true;
            this.error = true;
            this.cargado = true;
        }
    },
    (error) => {
      console.log(error);
      this.without_institution=true;
        this.error = true;
        this.cargado = true;
    });
  }


  cargarLugares(){
    /*console.log('Guardando referencia a la version actual');*/

    this.querySubscription = this.backendService.getPlaces().subscribe((res) => {
        if (res["errorCode"] > 0) {
            this.error = false;
            this.cargado = true;
            this.places = res["data"];
        } else {
            this.error = true;
            this.cargado = true;
        }
    },
    (error) => {
        this.error = true;
        this.cargado = true;
    });
  }

  setOnChangeNumberListener():void{

    this.patientFilterCtrl.valueChanges
    .pipe(takeUntil(this._onDestroy))
    .subscribe(() => {
      console.log("searching");
      this.searchPatient();
    });
  }

  searchPatient():void{
    let value = this.patientFilterCtrl.value;
    if(value.length>0){
      this.backendService.getCiudadanoLastAutocomplete(value).subscribe((res) => {
        console.log(res);
          if (res['errorCode'] > 0) {
            console.log(res["data"]);
            this.filteredPatients.next(res["data"]);
          }else{
            this.filteredPatients.next([]);
          }
      },
      (error) => {
        alert("Error saving data");
      });
    }
  }

  getLabelNotFound(){
    if  (this.selected_view=='institutional_user' || this.selected_view=='researcher'){
      return "not_numPacienteInstitution";
    } else{
      return "not_numPaciente";
    }

  }


  cargarSelector():void{
    /*console.log("Cargando selector");*/
    /*console.log(this.datos);*/
    // load the initial persons list
    this.filteredPatients.next(this.datos.slice());

    /*console.log(this.filteredPatients);*/
    // listen for search field value changes
    this.patientFilterCtrl.valueChanges
      .pipe(takeUntil(this._onDestroy))
      .subscribe(() => {
        this.filterPatients();
      });
  }


  ngAfterViewInit() {
    /*console.log(this.singleSelect);*/
    this.setInitialValue();
  }

    /**
   * Sets the initial value after the filteredPatients are loaded initially
   */
  protected setInitialValue() {
    this.filteredPatients
      .pipe(take(1), takeUntil(this._onDestroy))
      .subscribe(() => {
        this.singleSelect.compareWith = (a: any, b: any) => a && b && a.id === b.id;
      });
  }

  protected filterPatients() {
    if (!this.datos) {
      return;
    }
    // get the search keyword
    let search = this.patientFilterCtrl.value;
    if (!search) {
      this.filteredPatients.next(this.datos.slice());
      return;
    } else {
      search = search.toLowerCase();
    }
    // filter the patients
    this.filteredPatients.next(
      this.datos.filter(patient => patient.number.toLowerCase().indexOf(search) == 0)
    );
  }

  /*preventBackButton() {

    history.pushState(null, null, location.href);
    this.locationStrategy.onPopState(() => {
      if(this.editando==true || this.adding==true){
        this.finalizar();
      }
    })
  }*/
  

  finalizar(){
    // emitir un evento Output
      /*console.log("finalizando");*/
      this.pacienteSeleccionadoEvent.emit({'id': this.paciente.id, 'number': this.paciente.number});
  }

  reloadPaciente(event):void{
    /*console.log("On reload");*/
    let id = event['id'];
    this.editando=false;
    this.adding=false;
    this.addPacienteEvent.emit({'bool':false});
    if (id!=null){
      console.log("reloading");
      this.cargarPacientesYSeleccionar(id);
    }
  }

  onAddPaciente(){
    this.adding=true;
    this.editando=false;
    this.addPacienteEvent.emit({'bool':true});
  }
  onEditPaciente(){
    this.adding=false;
    this.editando=true;
    this.addPacienteEvent.emit({'bool':true});
  }

  cargarPacientesYSeleccionar(id){
    this.querySubscription = this.backendService.getCiudadanoLastEntriesAutocomplete().subscribe((res) => {
      if (res["errorCode"] > 0) {
          this.error = false;
          this.cargado = true;
          this.datos = res["data"];

          this.datos.forEach(element => {
            if(element.id==id){
              this.paciente=element;
              this.finalizar();
            }
          });
      } else {
          this.error = true;
          this.cargado = false;
      }
    },
    (error) => {
        this.error = true;
        this.cargado = false;
    });
  }


  ngOnDestroy() {
    this._onDestroy.next();
    this._onDestroy.complete();
  }

}
